import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=b1717c04&scoped=true&"
import script from "./OnBoarding.vue?vue&type=script&lang=js&"
export * from "./OnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=b1717c04&lang=scss&scoped=true&"
import style1 from "./OnBoarding.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1717c04",
  null
  
)

export default component.exports